import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE =
  "B&S Global Ventures | Import & Export Trading — Bags, Apparel, Footwear, Watches, Jewellery, Food Items";
const DEFAULT_DESCRIPTION =
  "B&S Global Ventures is an India-based import/export trading company specializing in Bags, Apparel, Footwear, Watches, Jewellery, and Food Items. We connect international wholesale buyers with verified Indian suppliers — offering sourcing, quality control, private labeling, and end-to-end export logistics (FOB/CIF/DDP).";
const DEFAULT_KEYWORDS =
  "import export trading company India, wholesale sourcing India, private label bags apparel footwear, B2B trading company India, export FOB CIF DDP, verified suppliers India, bulk sourcing jewellery watches food items";
const DEFAULT_CANONICAL = "https://bsglobalventures.com";
const DEFAULT_OG_IMAGE = `${DEFAULT_CANONICAL}/og-image.jpg`;

const organizationSchema = (description, canonical) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "B&S Global Ventures",
  url: canonical,
  logo: `${canonical}/logo.png`,
  description,
  address: {
    "@type": "PostalAddress",
    addressCountry: "IN",
  },
  contactPoint: {
    "@type": "ContactPoint",
    email: "info@bsglobalventures.com",
    telephone: "+91-90040-15183",
    contactType: "customer service",
  },
});

const serviceSchema = (description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Import & Export Trading",
  provider: {
    "@type": "Organization",
    name: "B&S Global Ventures",
  },
  description,
  areaServed: "Worldwide",
  serviceType: ["Export from India", "Import to India", "Wholesale Sourcing", "Private Label OEM"],
});

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  canonical = DEFAULT_CANONICAL,
  image = DEFAULT_OG_IMAGE,
  robots = "index, follow",
}) {
  const org = organizationSchema(description, canonical);
  const service = serviceSchema(description);

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="B&S Global Ventures" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:alt" content="B&S Global Ventures — Import & Export Trading from India" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content="B&S Global Ventures — Import & Export Trading from India" />

      <script type="application/ld+json">{JSON.stringify(org)}</script>
      <script type="application/ld+json">{JSON.stringify(service)}</script>
    </Helmet>
  );
}
